import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../../generic';
import FetcherIcon from '../../../generic/FetcherIcon';
import { DepthBadge } from '../../dependenciesV2/DependenciesTable/DependencyTableRow/DependencyTitle/DependencyTitle';
import type { Fetcher } from '../../../../../shared/fetchers';

import styles from './VendoredDependencyRow.module.less';

type Props = {
  depth: number;
  fetcher: Fetcher;
  locatorFull: string;
  packageName: string;
  version: string;
};

/**
 * Renders the main title content for a vendored dependency row.
 * Note that this is largely just a stripped-down version of the DependencyTitle component,
 * which you can find @app/components/projects/dependenciesV2/DependenciesTable/DependencyTableRow/DependencyTitle/DependencyTitle.tsx.
 *
 * That component has additional fields and functionality which we don't need, plus it is connected directly to the DepsV2 Redux store.
 */
const VendoredDependencyRowTitle: VoidFunctionComponent<Props> = ({
  depth,
  fetcher,
  locatorFull,
  packageName,
  version,
}) => (
  <div className={styles.titleRow}>
    <span className={styles.titleContent}>
      <span className={styles.sourceIcon}>
        <Icon icon={icons.boxArchive} />
      </span>
      <span className={styles.title}>
        {packageName}
      </span>
      <span className={styles.version}>
        ({version})
      </span>
    </span>
    <DepthBadge isDirect={depth <= 1} />
    <span className={styles.fetcher}>
      <FetcherIcon fetcher={fetcher} isSmallIcon />
      <span>
        {locatorFull}
      </span>
    </span>
  </div>
);

export default VendoredDependencyRowTitle;
